import classNames from "classnames";
import React from "react";

import FormGroup from "lib/components/FormControl/FormGroup";
import Input from "lib/components/FormControl/Input";
import NumberSwitch from "lib/components/FormControl/NumberSwitch";
import st from "lib/utils/index";

export default class OrderedProductPricelistItemFormGroup extends React.PureComponent {
  handlePropChange(prop, value, autoCalculateOtherProp = true) {
    const { value: orderedItem, onChange } = this.props;

    if (prop === "quantity") {
      const quantity = value;
      const minPersonsCount = quantity * (orderedItem.product_pricelist_item.min_persons_count || 0);
      const maxPersonsCount = quantity * (orderedItem.product_pricelist_item.max_persons_count || Infinity);
      let persons_count = orderedItem.persons_count;
      if (autoCalculateOtherProp) {
        persons_count = Math.min(maxPersonsCount, Math.max(minPersonsCount, orderedItem.persons_count));
      }
      onChange({
        ...orderedItem,
        quantity,
        persons_count,
      });
    } else if (prop === "persons_count") {
      const persons_count = value;
      const minQuantity =
        orderedItem.product_pricelist_item.min_persons_count > 0
          ? Math.floor(persons_count / orderedItem.product_pricelist_item.min_persons_count)
          : 0;
      const maxQuantity =
        orderedItem.product_pricelist_item.max_persons_count < Infinity
          ? Math.ceil(persons_count / orderedItem.product_pricelist_item.max_persons_count)
          : Infinity;
      let quantity = orderedItem.quantity;
      if (autoCalculateOtherProp) {
        quantity = Math.min(maxQuantity, Math.max(minQuantity, orderedItem.quantity));
      }
      if (orderedItem.product_pricelist_item.pricelist_type === "pricelist_by_order") {
        quantity = 1;
      }
      onChange({
        ...orderedItem,
        quantity,
        persons_count,
      });
    }
  }

  render() {
    const { value: orderedItem, name, error, valid = !error, onFocus, onBlur, wrapperClassName } = this.props;
    const item = orderedItem.product_pricelist_item;
    const showQuantityInput = item.pricelist_type !== "pricelist_by_person";
    const showPersonsCountInput = item.min_persons_count !== null || item.max_persons_count !== null;
    const isQuantityEditable = showQuantityInput && item.pricelist_type !== "pricelist_by_order";

    const quantityInput =
      showQuantityInput &&
      (isQuantityEditable ? (
        <NumberSwitch
          name={name}
          value={orderedItem.quantity}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={(v) => this.handlePropChange("quantity", v, !showQuantityInput || !showPersonsCountInput)}
          min={0}
        />
      ) : (
        <Input type="number" value={orderedItem.quantity} readOnly />
      ));
    const personsCountInput = showPersonsCountInput && (
      <NumberSwitch
        name={name}
        value={orderedItem.persons_count}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={(v) => this.handlePropChange("persons_count", v, !showQuantityInput || !showPersonsCountInput)}
        min={item.pricelist_type === "pricelist_by_order" ? orderedItem.min_persons_count : 0}
        max={item.pricelist_type === "pricelist_by_order" ? orderedItem.max_persons_count : undefined}
      />
    );

    return (
      <FormGroup
        name={name}
        error={error}
        valid={valid}
        label={item.display_name_with_price}
        className={wrapperClassName}
      >
        {showQuantityInput && showPersonsCountInput && (
          <div>
            <div className="field">{quantityInput}</div>
            <div className="field inline">
              <label>
                <i className="icon material-icons">people</i> {st.capitalize(I18n.t("attributes.persons_count"))}
              </label>
              {personsCountInput}
            </div>
          </div>
        )}
        {showQuantityInput && !showPersonsCountInput && quantityInput}
        {!showQuantityInput && showPersonsCountInput && personsCountInput}
      </FormGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/OrderedProductPricelistItemFormGroup.jsx